import { MortgageDocumentsView } from 'features/mortgage';

const MortgageDocumentsPage = () => <MortgageDocumentsView />;

export default MortgageDocumentsPage;
